<template>
  <div>
    <div class="flex-100 px-2 mb-6" v-show="!reportHeader.meldeanlass">
      <fake-input-frame :label="$t('COMPONENT_REPORT.REPORT_CAUSE')"
                        :disabled="isDisabled">
        <div class="layout-row px-4 pb-2 flex layout-align-start-center">
          <label class="mr-8" :style="{'color': isDisabled  ? '#BDBDBD' : compColor.isInDarkMode ? '#cfd8dc' : '#455a64', 'font-size': denseFields ? '0.9em' : '16px'}">
            {{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_QUESTION_REPORT_REASON') }}</label>

          <validation-provider tag="div"
                               :name="path + '.st_ende_therapie'"
                               :ref="path + '.st_ende_therapie'"
                               rules=""
                               class="layout-row"
                               v-slot="{ errors }">
            <v-radio-group :dense="denseFields" v-model="model[path].st_ende_therapie" row hide-details :error-messages="errors[0]"
                           class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_BEGINN_OF_THERAPY')"
                       value="N" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_END_OF_THERAPY')"
                       value="J" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
            </v-radio-group>
          </validation-provider>
        </div>
      </fake-input-frame>
    </div>

    <div class="flex-100 px-2 mb-6" v-if="reportHeader.meldeanlass === 'behandlungsende'">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_END_OF_THERAPY')"
                        :disabled="isDisabled">
        <div class="layout-column px-2 pb-2 pt-2 flex">
          <div class="layout-row layout-wrap mt-2">

            <!-- Ende Datum des ersten Elements, wird nur angezeigt, wenn noch keine id -->

            <div class="flex-gt-sm-50 flex-100 px-2" v-if="!id">
              <validation-provider tag="div"
                                   :name="pathRadiation + '.st_ende_datum'"
                                   :ref="pathRadiation + '.st_ende_datum'"
                                   :rules="{required:true,german_date:true,date_not_in_future:true,date_must_be_greater_than_diagnosis:diagDate, date_must_be_lesser_than_death:[deathDate, null]}"
                                   v-slot="{ errors }">
                <lx-datepicker
                    :color="compColor.textInput"
                    :auto-focus="true"
                    :name="pathRadiation + '.0.st_ende_datum'"
                    :label="$t('FORMS_DIVERSE.MODULE_RADIATION_DATE_END') + ' *'"
                    class="mb-4"
                    @input="validateDependingFields(model[pathRadiation][0].st_ende_datum)"
                    :dense="denseFields"
                    :hide-details="!errors || errors.length <= 0"
                    :disabled="isDisabled"
                    :error="errors[0]"
                    v-model="model[pathRadiation][0].st_ende_datum"
                ></lx-datepicker>
              </validation-provider>
            </div>

            <!-- Grund für Ende  -->

            <div class="flex-gt-sm-50 flex-100 px-2">
              <validation-provider tag="div"
                                   :name="path + '.st_ende_grund'"
                                   :ref="path + '.st_ende_grund'"
                                   rules="required"
                                   v-slot="{ errors }">
                <v-select
                  :color="compColor.primeColor"
                  :label="$t('FORMS_DIVERSE.MODULE_RADIATION_REASON_END') + ' *'"
                  v-model="model[path].st_ende_grund"
                  :items="ST_Ende_GrundTypes"
                  outlined
                  :disabled="isDisabled"
                  :dense="denseFields"
                  :hide-details="!errors || errors.length <= 0"
                  :error-messages="errors[0]"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!-- Beginn der Therapie -->

    <div class="flex-100 px-2 mb-6" v-if="!!reportHeader.meldeanlass">
      <fake-input-frame :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_BEGINN_OF_THERAPY')"
                        :disabled="isDisabled">
        <div class="layout-row px-4 py-2 layout-wrap">

          <!-- Soll verlinkt werden ? -->

          <div class="flex-100 mb-2 layout-row" v-if="model[path].st_ende_therapie === 'J'">
            <v-radio-group :dense="denseFields" v-model="isLinkedTherapy" row hide-details
                           class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_SYST_LABEL_END_THERAPY_LINK')"
                       value="J" :disabled="isDisabled || listOfUnlinkedTherapies.length === 0" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
              <v-radio :label="$t('FORMS_DIVERSE.MODULE_SYST_LABEL_END_THERAPY_MANUALLY_INPUT')"
                       @change="unlinkTherapy"
                       value="N" :disabled="isDisabled" :color="compColor.primeColor" :dark="compColor.isInDarkMode">
              </v-radio>
            </v-radio-group>
          </div>

          <!-- Beginn der Bestrahlung -->

          <div class="flex-gt-sm-50 flex-100 pr-2 mt-2" v-show="reportHeader.meldeanlass === 'behandlungsbeginn' || isLinkedTherapy === 'N'">
            <validation-provider tag="div"
                                 :name="pathRadiation + '.0.st_beginn_datum'"
                                 :ref="pathRadiation + '.0.st_beginn_datum'"
                                 :rules="{required:true,german_date:true,date_not_in_future:true,date_must_be_lesser_than:model[pathRadiation].st_ende_datum,date_must_be_greater_than_diagnosis:diagDate,date_must_be_lesser_than_death:[deathDate, null]}"
                                 v-slot="{ errors }">
              <lx-datepicker
                :color="compColor.textInput"
                :auto-focus="!id && reportHeader.meldeanlass === 'behandlungsbeginn'"
                :name="pathRadiation + '.0.st_beginn_datum'"
                :label="$t('FORMS_DIVERSE.MODULE_RADIATION_DATE_START') + ' *'"
                class="mb-4"
                @input="updateStartDatesAfterChange()"
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :disabled="isDisabled || (!!model[path].linked_therapy && reportHeader.meldeanlass === 'behandlungsbeginn')"
                :error="errors[0]"
                v-model="model[pathRadiation][0].st_beginn_datum"
              ></lx-datepicker>
            </validation-provider>
          </div>

          <!-- Verlinkter Therapiebeginn -->

          <div class="flex-gt-sm-50 flex-100 pr-2 mt-2" v-show="isLinkedTherapy === 'J'">
            <validation-provider tag="div"
                                 :name="path + '.linked_therapy'"
                                 :ref="path + '.linked_therapy'"
                                 :rules="{required: isLinkedTherapy === 'J'}"
                                 v-slot="{ errors }">
              <v-select
                :color="compColor.primeColor"
                :label="$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_LINKED_THERAPY') + ' *'"
                v-model="linkedId"
                :items="listOfUnlinkedTherapies"
                outlined
                @change="openLinkDialog"
                item-value="_id"
                :disabled="isDisabled"
                :dense="denseFields"
                :hide-details="!errors || errors.length <= 0"
                :error-messages="errors[0]"
                :menu-props="{ bottom: true, offsetY: true }"
                :dark="compColor.isInDarkMode">
                <template v-slot:selection='{ item }'>
                  <span v-if="!compColor.isInDarkMode"
                        style="width: 100%;overflow: hidden; text-overflow: ellipsis;white-space: nowrap;"
                        :style="{ 'color': isDisabled ? 'rgba(0, 0, 0, 0.38)' : '#445a64', 'font-size': denseFields ? '14.4px !important' : '16px !important'}">
                    {{ formatDateOfRadiationTherapy(item) }}</span>
                  <span v-if="compColor.isInDarkMode"
                        style="width: 100%;overflow: hidden; text-overflow: ellipsis;white-space: nowrap;"
                        :style="{ 'color': isDisabled ? 'rgba(255, 255, 255, 0.5)' : 'white', 'font-size': denseFields ? '14.4px !important' : '16px !important'}">
                    {{ formatDateOfRadiationTherapy(item) }}</span>
                </template>
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on"
                               :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                    <v-list-item-content class="py-0" style="">
                      <label style="cursor:pointer;"
                             :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                             class="lighten-4 text--darken-2">{{ formatDateOfRadiationTherapy(item) }}</label>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-select>
            </validation-provider>
          </div>

          <!-- Info wenn Therapiebeginn ist verlinkt mit Therapieende -->

          <div v-if="!!model[path].linked_therapy && model[path].linked_therapy !== '000000000000000000000000' && reportHeader.meldeanlass === 'behandlungsbeginn' && model[path].st_ende_therapie !== 'J'"
               class="flex-gt-sm-100 mb-2 pa-3 report layout-row layout-align-start-center" style="border:1px solid;border-radius: 9px;"
               :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
               :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
            <div class="layout-column layout-align-center-center mr-3">
              <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
            </div>
            <span style="font-size: 14px;" v-bind:class="compColor.primeClass">{{ $t('FORMS_DIVERSE.MODULE_SYST_THERAPY_LINKED_THERAPY_MESSAGE') }}</span>
          </div>
        </div>
      </fake-input-frame>
    </div>

    <!-- Intension der Bestrahlung -->

    <div class="flex-gt-sm-50 flex-100 px-2" v-if="!!reportHeader.meldeanlass">
      <validation-provider tag="div"
                           :name="path + '.st_intention'"
                           :ref="path + '.st_intention'"
                           rules="required"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_SYST_INTENTION') + ' *'"
          v-model="model[path].st_intention"
          :items="ST_IntentionTypes"
          outlined
          :disabled="isDisabled"
          :dense="denseFields"
          :hide-details="!errors || errors.length <= 0"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Stellung zur OP -->

    <div class="flex-gt-sm-50 flex-100 px-2" v-if="!!reportHeader.meldeanlass">
      <validation-provider tag="div"
                           :name="path + '.st_stellung_op'"
                           :ref="path + '.st_stellung_op'"
                           rules="required"
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.MODULE_RADIATION_POSITION_TO_OP') + ' *'"
          v-model="model[path].st_stellung_op"
          :items="ST_Stellung_OPTypes"
          outlined
          :disabled="isDisabled"
          :dense="denseFields"
          :hide-details="!errors || errors.length <= 0"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- BUTTON ADD SINGLE RADIATION -->

    <div v-if="!!reportHeader.meldeanlass" class="flex-gt-sm-100 flex-100">
      <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center pa-2">
        <lx-btn :disabled="isDisabled || Boolean(model[path].linked_therapy)"
                icon="add_circle"
                :color="compColor.primeColor"
                :iconColor="'white'"
                :tooltip="$t('FORMS_DIVERSE.MODULE_RADIATION_TOOLTIP_ADD_BTN')"
                :label="$t('FORMS_DIVERSE.MODULE_RADIATION_ADD_RADIATION')"
                iconSize="21"
                :width="'auto'"
                :height="35"
                classes="text-none"
                @click="addNewRadiation(model[pathRadiation].length)"
        ></lx-btn>
      </div>

      <v-divider class="mx-3 flex-gt-sm-100 flex-100 my-1 pb-1" v-bind:style="{'border-color':compColor.lightDivider}" v-if="!!reportHeader.meldeanlass"></v-divider>

      <!-- Applikationsart -->

      <div :key="index" v-for="(item, index) in model[pathRadiation]"
           class="layout-row flex-gt-sm-100 pa-0 mx-2 mt-2 mb-4 flex"
           :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
           style="border-radius:4px;"
           :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

        <div class="layout layout-column mb-4">
          <div class="flex-gt-sm-100 flex-100 px-2 my-2 layout layout-row layout-wrap" v-if="!!reportHeader.meldeanlass">
            <validation-provider tag="div"
                                 class="flex-gt-sm-50 flex-100 my-2"
                                 :name="pathRadiation + '.' + index + '.selectedKindOfApplication'"
                                 :ref="pathRadiation + '.' + index + '.selectedKindOfApplication'"
                                 rules="">
              <v-btn-toggle v-model="item.selectedKindOfApplication"
                            dense
                            :mandatory="!!item.selectedKindOfApplication"
                            class="ml-2"
                            style="margin-top:2px;"
                            :color="compColor.prime">
                <v-btn :key="listIndex" v-for="(kind, listIndex) in listOfApplications" :value="kind.value"
                       :disabled="isDisabled"
                       @click="setKindOfApplication(kind.value, index)">
                  {{ kind.text }}
                </v-btn>
              </v-btn-toggle>
            </validation-provider>

            <!-- Datum Ende der Bestrahlung -->

            <div class="flex-gt-sm-50 flex-100 pl-2 pr-1 mt-2" v-if="model[path].st_ende_therapie === 'J'">
              <validation-provider tag="div"
                                   :name="pathRadiation + '.' + index + '.st_ende_datum'"
                                   :ref="pathRadiation + '.' + index + '.st_ende_datum'"
                                   :rules="{required:true,german_date:true,date_not_in_future:true,date_must_be_greater_than:item.st_beginn_datum,date_must_be_greater_than_diagnosis:diagDate, date_must_be_lesser_than_death:[deathDate, null]}"
                                   v-slot="{ errors }">
                <lx-datepicker
                    :color="compColor.textInput"
                    :name="pathRadiation + '.' + index + '.st_ende_datum'"
                    :label="$t('FORMS_DIVERSE.MODULE_RADIATION_DATE_END') + ' *'"
                    class="mb-4"
                    :dense="denseFields"
                    :hide-details="!errors || errors.length <= 0"
                    :disabled="isDisabled"
                    :error="errors[0]"
                    v-model="item.st_ende_datum"
                ></lx-datepicker>
              </validation-provider>
            </div>

            <!-- Applikationsart -->

            <div v-if="item.selectedKindOfApplication" class="layout-row layout-wrap flex-100 ml-2 mb-4">
              <div class="flex py-2 pl-2" style="min-width: 220px;">
                <div class="pr-2 pt-1" :key="typeParentIndex" v-for="(type, typeParentIndex) in ST_ApplikationsartTypes[item.selectedKindOfApplication].types">
                  <label v-if="type.text" style="font-style: italic;" :style="{ 'color': compColor.isInDarkMode ? '#cfd8dc' : isDisabled ? '#BDBDBD' : ''}">{{ type.text }}</label>
                  <validation-provider tag="div"
                                       :name="pathRadiation + '.' + index + '.st_applikationsart.' +  item.selectedKindOfApplication + '.' + type.value"
                                       :ref="pathRadiation + '.' + index + '.st_applikationsart.' +  item.selectedKindOfApplication + '.' + type.value"
                                       :rules="{ required: type.required }"
                                       v-slot="{ errors }">
                    <v-radio-group :dense="denseFields"
                                   v-model="item.st_applikationsart[item.selectedKindOfApplication][type.value]"
                                   :error-messages="errors[0]"
                                   :hide-details="!errors || errors.length <= 0"
                                   class="mx-0 pa-0 pb-2 my-2 layout-column"
                                   :dark="compColor.isInDarkMode"
                                   style="flex:unset;margin-top: 10px;">
                      <v-radio :key="typeIndex" v-for="(elem, typeIndex) in type.list"
                               :label="elem.text"
                               :disabled="isDisabled"
                               :error-messages="errors[0]"
                               style="font-size: 15px;"
                               :value="elem.value"
                               :color="compColor.primeColor"
                               :dark="compColor.isInDarkMode">
                      </v-radio>
                    </v-radio-group>
                  </validation-provider>
                </div>

                <!-- Reset kind of application via button  -->

                <v-btn :color="compColor.primeColor"
                       :dark="compColor.isInDarkMode"
                       depressed
                       text
                       width="auto"
                       class="white--text text-none layout-row layout-align-start-center ml-n2 px-2"
                       :class="denseFields ? 'pl-2' : ''"
                       @click="resetKindOfApplication(index)"
                       v-show="getLengthOfSelectedKindOfApplication(index).length > 0 && !isDisabled && !ST_ApplikationsartTypes[item.selectedKindOfApplication].required"
                       :disabled="isDisabled"
                       :title="$t('buttons.deleteSelection.title')">
                  <v-icon :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass"
                          size="24">mdi-arrow-up-bold
                  </v-icon>
                  <span class="ml-2" :class="compColor.primeHighlightClass + '--text'">{{ $t('buttons.deleteSelection.value') }}</span>
                </v-btn>
              </div>
            </div>
          </div>

          <div class="layout row layout-wrap px-4 pb-3">

            <!-- Strahlenart -->

            <div class="flex-gt-sm-100 flex-100 px-2" v-if="!!reportHeader.meldeanlass && item.selectedKindOfApplication && item.selectedKindOfApplication!=='sonstige'">
              <validation-provider tag="div"
                                   :name="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.strahlenart'"
                                   :ref="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.strahlenart'"
                                   rules=""
                                   v-slot="{ errors }">
                <v-select
                    :color="compColor.primeColor"
                    :label="$t('FORMS_DIVERSE.MODULE_RADIATION_KIND_OF_RADIATION')"
                    v-model="item.st_applikationsart[item.selectedKindOfApplication].strahlenart"
                    :items="ST_ApplikationsartTypes[item.selectedKindOfApplication].strahlenart"
                    outlined
                    clearable
                    :disabled="isDisabled"
                    :dense="denseFields"
                    :hide-details="!errors || errors.length <= 0"
                    :error-messages="errors[0]"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>

            <!-- Zielgebiet der Bestrahlung -->

            <div class="flex-gt-sm-50 flex-100 px-2 layout-row" v-if="!!reportHeader.meldeanlass && item.selectedKindOfApplication">
              <validation-provider tag="div"
                                   :name="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.zielgebiet.' + item.selectedVersionOfDestination"
                                   :ref="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.zielgebiet.' + item.selectedVersionOfDestination"
                                   rules="required"
                                   class="flex"
                                   v-slot="{ errors }">
                <v-autocomplete
                    :color="compColor.primeColor"
                    v-model="item.st_applikationsart[item.selectedKindOfApplication].zielgebiet[item.selectedVersionOfDestination]"
                    outlined
                    :dense="denseFields"
                    :disabled="isDisabled"
                    @change="deleteSideOfDestination(index)"
                    :hide-details="!errors || errors.length <= 0"
                    :label="$t('FORMS_DIVERSE.MODULE_RADIATION_DESTINATION') + ' *'"
                    :error-messages="errors[0]"
                    :dark="compColor.isInDarkMode"
                    :items="item.destinationList">
                  <template v-slot:no-data>
                    <div class="layout-row pt-1 pb-1 pl-3 pr-3">
                      <div class="flex layout-row mr-3 lighten-4 text--darken-2"
                           :class="compColor.isInDarkMode ? ['white--text'] : []"
                           :style="{'font-size': denseFields ? '14.4px !important' : '16px !important'}">
                        {{ $t('NO_SEARCH_RESULT') }}
                      </div>
                    </div>
                  </template>
                  <template v-slot:item="{item, on, parent, attrs}">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0 layout-row">
                        <div class="py-0 layout-row"
                             :class="compColor.isInDarkMode ? ['white--text'] : []"
                             :style="{'font-size': denseFields ? '14.4px !important' : '16px !important'}">
                          <lx-text-highlight :text="item.text" :search-string="parent._props.searchInput"
                                             :color="compColor.prime"></lx-text-highlight>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </validation-provider>

              <!-- Version Zielgebiet der Bestrahlung -->

              <div class="layout-column pt-0">
                <label style="font-size: 12px" class="pt-0 mt-n1 pl-2 layout-align-center-center layout-row"
                       :style="{'color': isDisabled  ? '#BDBDBD' : compColor.isInDarkMode ? '#cfd8dc' : '#455a64'}"
                >{{ $t('FORMS_DIVERSE.MODULE_RADIATION_DESTINATION_VERSION') }}</label>
                <v-btn-toggle v-model="item.selectedVersionOfDestination"
                              dense
                              :mandatory="!!item.selectedVersionOfDestination"
                              class="ml-2"
                              :color="compColor.prime">
                  <v-btn value="code_version_2014"
                         height="25"
                         :disabled="isDisabled"
                         @click="deleteValuesOfDestination('code_version_2021', index)">
                    2014
                  </v-btn>
                  <v-btn value="code_version_2021"
                         height="25"
                         :disabled="isDisabled"
                         @click="deleteValuesOfDestination('code_version_2014', index)">
                    2021
                  </v-btn>
                </v-btn-toggle>
              </div>
            </div>

            <!-- Seite des Zielgebietes der Bestrahlung -->

            <div class="flex-gt-sm-50 flex-100 px-2" v-if="!!reportHeader.meldeanlass && item.selectedKindOfApplication">
              <validation-provider tag="div"
                                   :name="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.seite_zielgebiet'"
                                   :ref="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.seite_zielgebiet'"
                                   rules="required"
                                   v-slot="{ errors }">
                <v-select
                    :color="compColor.primeColor"
                    :label="$t('FORMS_DIVERSE.MODULE_RADIATION_DESTINATION_SIDE') + ' *'"
                    v-model="item.st_applikationsart[item.selectedKindOfApplication].seite_zielgebiet"
                    :items="getSTZielgebietSeiteList(index)"
                    outlined
                    :disabled="isDisabled"
                    :dense="denseFields"
                    :hide-details="!errors || errors.length <= 0"
                    :error-messages="errors[0]"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>

            <!-- Gesamtdosis Wert -->

            <div class="flex-gt-sm-50 flex-100 px-2" v-if="!!reportHeader.meldeanlass && reportHeader.meldeanlass === 'behandlungsende' && item.selectedKindOfApplication">
              <validation-provider tag="div"
                                   :name="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.gesamtdosis.dosis'"
                                   :ref="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.gesamtdosis.dosis'"
                                   :rules="{decimal:1, min_value: 0.1, required: !!item.st_ende_datum, overall_dosage_must_be_greater_than_single_dosage: [item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.dosis]}"
                                   v-slot="{ errors }">
                <lx-numberfield :disabled="isDisabled"
                                :dense="denseFields"
                                @input="setUnitAfterDosage(item.st_applikationsart[item.selectedKindOfApplication].gesamtdosis.dosis, index, 'gesamtdosis')"
                                :hide-details="!errors || errors.length <= 0"
                                v-model="item.st_applikationsart[item.selectedKindOfApplication].gesamtdosis.dosis"
                                :label="formatRequiredLabel('FORMS_DIVERSE.MODULE_RADIATION_TOTAL_DOSE', index)"
                                separator=","
                                :error-messages="errors[0]"
                ></lx-numberfield>
              </validation-provider>
            </div>

            <!-- Gesamtdosis Einheit -->

            <div class="flex-gt-sm-50 flex-100 px-2" v-if="!!reportHeader.meldeanlass && reportHeader.meldeanlass === 'behandlungsende' && item.selectedKindOfApplication">
              <validation-provider tag="div"
                                   :name="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.gesamtdosis.einheit'"
                                   :ref="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.gesamtdosis.einheit'"
                                   :rules="{required: !!item.st_ende_datum}"
                                   v-slot="{ errors }">
                <v-select
                    :color="compColor.primeColor"
                    :label="formatRequiredLabel('FORMS_DIVERSE.MODULE_RADIATION_UNIT_TOTAL_DOSE', index)"
                    v-model="item.st_applikationsart[item.selectedKindOfApplication].gesamtdosis.einheit"
                    :items="ST_ApplikationsartTypes[item.selectedKindOfApplication].units"
                    outlined
                    :disabled="isDisabled"
                    :dense="denseFields"
                    :hide-details="!errors || errors.length <= 0"
                    :error-messages="errors[0]"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>

            <!-- Einzeldosis Wert -->

            <div class="flex-gt-sm-50 flex-100 px-2" v-if="!!reportHeader.meldeanlass && item.selectedKindOfApplication">
              <validation-provider tag="div"
                                   :name="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.einzeldosis.dosis'"
                                   :ref="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.einzeldosis.dosis'"
                                   :rules="{decimal:1, min_value: 0.1, required: !!(item.st_ende_datum || item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.einheit), single_dosage_must_be_lesser_than_overall_dosage: [item.st_applikationsart[item.selectedKindOfApplication].gesamtdosis.dosis]}"
                                   v-slot="{ errors }">
                <lx-numberfield :disabled="isDisabled"
                                :dense="denseFields"
                                @input="setUnitAfterDosage(item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.dosis, index,'einzeldosis')"
                                v-model="item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.dosis"
                                :label="formatRequiredLabel('FORMS_DIVERSE.MODULE_RADIATION_SINGLE_DOSE', index, item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.einheit)"
                                separator=","
                                :hide-details="!errors || errors.length <= 0"
                                :error-messages="errors[0]"
                ></lx-numberfield>
              </validation-provider>
            </div>

            <!-- Einzeldosis Einheit -->

            <div class="flex-gt-sm-50 flex-100 px-2" v-if="!!reportHeader.meldeanlass && item.selectedKindOfApplication">
              <validation-provider tag="div"
                                   :name="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.einzeldosis.einheit'"
                                   :ref="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.einzeldosis.einheit'"
                                   :rules="{ required: !!item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.dosis }"
                                   v-slot="{ errors }">
                <v-select
                    :color="compColor.primeColor"
                    :label="formatRequiredLabel('FORMS_DIVERSE.MODULE_RADIATION_UNIT_SINGLE_DOSE', index, item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.dosis)"
                    v-model="item.st_applikationsart[item.selectedKindOfApplication].einzeldosis.einheit"
                    :items="ST_ApplikationsartTypes[item.selectedKindOfApplication].units"
                    outlined
                    :disabled="isDisabled"
                    :dense="denseFields"
                    :hide-details="!errors || errors.length <= 0"
                    :error-messages="errors[0]"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>

            <!-- Boost -->

            <div class="flex-gt-sm-100 flex-100 px-2" v-if="!!reportHeader.meldeanlass && item.selectedKindOfApplication && ST_ApplikationsartTypes[item.selectedKindOfApplication].boost">
              <validation-provider tag="div"
                                   :name="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.boost'"
                                   :ref="pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.boost'"
                                   rules=""
                                   v-slot="{ errors }">
                <v-select
                    :color="compColor.primeColor"
                    :label="$t('FORMS_DIVERSE.MODULE_RADIATION_BOOST')"
                    v-model="item.st_applikationsart[item.selectedKindOfApplication].boost"
                    :items="BoostTypes"
                    outlined
                    :disabled="isDisabled"
                    :dense="denseFields"
                    :hide-details="!errors || errors.length <= 0"
                    :error-messages="errors[0]"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :dark="compColor.isInDarkMode">
                  <template v-slot:item="{ item, on, attrs }">
                    <v-list-item v-on="on"
                                 :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                      <v-list-item-content class="py-0">
                        <label style="cursor:pointer;"
                               :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                               class="lighten-4 text--darken-2">{{ item.text }}</label>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
              </validation-provider>
            </div>
          </div>
        </div>

        <!-- Delete-Button -->

        <div class="layout-column layout-align-center-center px-3"
             :class="{'grey lighten-2': !compColor.isInDarkMode}"
             :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
          <lx-btn @click="deleteRadiation(index, pathRadiation + '.' + index + '.st_applikationsart.' + item.selectedKindOfApplication + '.boost')"
                  :color="compColor.primeColor"
                  :iconColor="'white'"
                  iconSize="21"
                  :tooltip="$t('FORMS_DIVERSE.MODULE_RADIATION_TOOLTIP_DELETE_BTN')"
                  :width="35"
                  :height="35"
                  :disabled="isDisabled || (model[pathRadiation] && model[pathRadiation].length === 1) || Boolean(model[path].linked_therapy)"
                  icon="delete_forever">

          </lx-btn>
        </div>
      </div>
    </div>

    <link-dialog
      title="FORMS_DIVERSE.MODULE_RADIATION_TAKE_OVER_POPUP_HEADER"
      message="FORMS_DIVERSE.MODULE_RADIATION_TAKE_OVER_POPUP_TEXT"
      :showLinkDialog="showLinkDialog"
      :isLoading="isLoading || updateIsRunning"
      @set-show-link-dialog="setLinkedBaseData"
      @close-link-dialog="closeLinkDialog">
    </link-dialog>
  </div>
</template>

<script>
import metaData from '../shared/formsMetaData'
import utils from '../../../common/utils'
import LinkDialog from './LinkConfirmDialog'

import lodash from 'lodash'

export default {
  name: "GrunddatenStrahlentherapie",
  mixins: [metaData, utils],
  components: {
    LinkDialog
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        base: {},
        bestrahlung: {}
      })
    },
    path: {
      type: String,
      default: 'base'
    },
    pathRadiation: {
      type: String,
      default: 'bestrahlung'
    },
    id: {
      type: String
    },
    isDisabled: {
      type: Boolean
    },
    validationRef: {
      type: Object,
      default: () => ({})
    },
    reportHeader: {
      type: Object,
      default: () => ({})
    },
    patientId: {
      type: String
    },
    reloadUnlinkedTherapies: {
      type: Boolean,
      default: false
    },
    isLoading: Boolean
  },
  data () {
    return {
      modelBase: {},
      model: {
        base: {},
        bestrahlung: [{ st_applikationsart: {} }]
      },
      ST_IntentionTypes: null,
      ST_Stellung_OPTypes: null,
      ST_Ende_GrundTypes: null,
      ST_Seite_ZielgebietTypes: null,
      ST_Seite_ZielgebietTypes_onlyLR: null,
      ST_ApplikationsartTypes: null,
      ST_ZielgebietTypes_2014: [],
      ST_ZielgebietTypes_2021: [],
      BoostTypes: null,
      listOfApplications: [
        { value: 'perkutan', text: 'Perkutan'},
        { value: 'kontakt', text: 'Kontakt'},
        { value: 'metabolisch', text: 'Metabolisch'},
        { value: 'sonstige', text: 'Sonstige'}
      ],
      listOfUnlinkedTherapies: [],
      isLinkedTherapy: 'N',
      linkedId: null,
      showLinkDialog: false,
      updateIsRunning: false
    }
  },
  created () {
    this.ST_IntentionTypes = this.formsMetaData.ST_IntentionTypes
    this.ST_Stellung_OPTypes = this.formsMetaData.ST_Stellung_OPTypes
    this.ST_Ende_GrundTypes = this.formsMetaData.ST_Ende_GrundTypes
    this.ST_ZielgebietTypes_2014 = this.formsMetaData.ST_ZielgebietTypes2014
    this.ST_ZielgebietTypes_2021 = this.formsMetaData.ST_ZielgebietTypes2021
    this.ST_Seite_ZielgebietTypes = this.formsMetaData.ST_Seite_ZielgebietTypes
    this.ST_Seite_ZielgebietTypes_onlyLR = this.formsMetaData.ST_Seite_ZielgebietTypes_onlyLR
    this.ST_ApplikationsartTypes = this.formsMetaData.ST_ApplikationsartTypes
    this.BoostTypes = this.formsMetaData.BoostTypes
  },
  methods: {
    /**
     * Check if one or more kind of application are selected to show/hide clear-button
     *
     * @param index
     * @returns {*[]}
     */
    getLengthOfSelectedKindOfApplication (index) {
      let kindOfApplicationsArray = []

      if (this.ST_ApplikationsartTypes[this.model[this.pathRadiation][index].selectedKindOfApplication].types) {
        this.ST_ApplikationsartTypes[this.model[this.pathRadiation][index].selectedKindOfApplication].types.forEach(type => {
          if (this.model[this.pathRadiation][index] && this.model[this.pathRadiation][index].st_applikationsart[this.model[this.pathRadiation][index].selectedKindOfApplication][type.value]) {
            kindOfApplicationsArray.push(this.model[this.pathRadiation][index].st_applikationsart[this.model[this.pathRadiation][index].selectedKindOfApplication][type.value])
          }
        })
      }

      return kindOfApplicationsArray
    },

    /**
     * Set list of destination of radiation to each single radiation in dependency to selected version (after change and initial)
     *
     * @param index The index of selected radiation
     */
    setSTZielgebietList (index) {
      this.$nextTick(() => {
        this.$set(this.model[this.pathRadiation][index], 'destinationList', !this.model[this.pathRadiation][index].selectedVersionOfDestination || this.model[this.pathRadiation][index].selectedVersionOfDestination === 'code_version_2021' ? this.ST_ZielgebietTypes_2021 : this.ST_ZielgebietTypes_2014)
      })
    },

    /**
     * Return list of side location of destination to each single radiation in dependency to destination and version
     *
     * @param index The index of selected radiation
     * @returns {null}
     */
    getSTZielgebietSeiteList (index) {
      const selectedKindOfApplication = this.model[this.pathRadiation][index].selectedKindOfApplication
      const destination = this.model[this.pathRadiation][index].st_applikationsart[selectedKindOfApplication].zielgebiet.code_version_2021
      const isLROnly = this.ST_ZielgebietTypes_2021.find(elem => elem.value === destination)

      return this.model[this.pathRadiation][index].selectedVersionOfDestination === 'code_version_2021' && isLROnly && isLROnly.onlyLR ? this.ST_Seite_ZielgebietTypes_onlyLR : this.ST_Seite_ZielgebietTypes
    },

    /**
     * Delete actually properties of destination after switching version of destination
     *
     * @param destinationToDelete
     * @param index
     */
    deleteValuesOfDestination (destinationToDelete, index) {
      const selectedKindOfApplication = this.model[this.pathRadiation][index].selectedKindOfApplication
      const selectedVersionOfDestination = this.model[this.pathRadiation][index].selectedVersionOfDestination
      // delete destination property e.g. code_version_2014
      this.$delete(this.model[this.pathRadiation][index].st_applikationsart[selectedKindOfApplication].zielgebiet, destinationToDelete)

      const field = this.pathRadiation + '.st_applikationsart.' + selectedKindOfApplication + '.zielgebiet.' + selectedVersionOfDestination

      // delete side of destination, if it is not part of new list
      if (destinationToDelete === 'code_version_2014') {
       this.deleteSideOfDestination(index)
      }

      // trigger auto save after changes
      if (this.validationRef?.fields[field]) {
        this.validationRef.fields[field].changed = true
      }

      this.setSTZielgebietList(index)
    },

    /**
     * Delete side of destination if not part of list
     *
     * @param index
     */
    deleteSideOfDestination (index) {
      const selectedKindOfApplication = this.model[this.pathRadiation][index].selectedKindOfApplication
      const sideOfDestination = this.model[this.pathRadiation][index].st_applikationsart[selectedKindOfApplication].seite_zielgebiet
      const ST_ZielgebietSeiteList = this.getSTZielgebietSeiteList(index)

      if (sideOfDestination && !ST_ZielgebietSeiteList.find(elem => elem.value === sideOfDestination)) {
        this.$delete(this.model[this.pathRadiation][index].st_applikationsart[selectedKindOfApplication], 'seite_zielgebiet')
      }
    },

    /**
     * Reset selected radio-button of kind of application and trigger dirty flag of validator for save
     *
     * @param index
     */
    resetKindOfApplication (index) {
      // delete all selected sub elements of selected kind of application
      const selectedKindOfApplication = this.model[this.pathRadiation][index].selectedKindOfApplication
      const applicationTypes = this.ST_ApplikationsartTypes[selectedKindOfApplication].types || []

      applicationTypes.forEach(type => {
        this.$delete(this.model[this.pathRadiation][index].st_applikationsart[selectedKindOfApplication], type.value)
      })

      // set dirty flag of first element of selected kind of application and trigger save
      const firstElement = this.ST_ApplikationsartTypes[selectedKindOfApplication]?.types[0]?.value ? this.ST_ApplikationsartTypes[selectedKindOfApplication].types[0].value : ''
      this.validationRef.fields[this.pathRadiation + '.'+ index +'.st_applikationsart.' +  selectedKindOfApplication + '.' + firstElement].changed = true
    },

    /**
     * Set unit of dosage automatically, if kind of application is perkutan or kontakt
     *
     * @param dosage The value of the selected dosage
     * @param radiationIndex The index of selected single radiation
     * @param field The name of selected field (e.g. gesamtdosis)
     */
    setUnitAfterDosage (dosage, radiationIndex, field) {
      const selectedKindOfApplication = this.model[this.pathRadiation][radiationIndex].selectedKindOfApplication

      if (selectedKindOfApplication === 'perkutan' || selectedKindOfApplication === 'kontakt' || selectedKindOfApplication === 'sonstige') {
        this.$set(this.model[this.pathRadiation][radiationIndex].st_applikationsart[selectedKindOfApplication][field], 'einheit', dosage ? 'Gy' : null)
      }

      // delete unit after manually deleting dosage, if kind of application is metabolisch
      if (this.selectedKindOfApplication === 'metabolisch' && !dosage) {
        this.$set(this.model[this.pathRadiation][radiationIndex].st_applikationsart[selectedKindOfApplication][field], 'einheit', null)
      }
    },

    /**
     * Update all other start dates in list of radiation, if date of first radiation has changes
     */
    updateStartDatesAfterChange () {
      if (this.model[this.pathRadiation] && this.model[this.pathRadiation].length > 1) {

        this.$nextTick(() => {
          this.model[this.pathRadiation].forEach((radiation, index) => {
            if (index > 0) {
              this.$set(radiation, 'st_beginn_datum', this.model[this.pathRadiation][0].st_beginn_datum)
            }
          })
        })
      }
    },

    /**
     * Validate fields depending on end date of radiation
     */
    validateDependingFields (date) {
      // overwrite value only if there is no date or value is empty
      if (!this.model[this.path].st_ende_grund || !date) {
        this.$set(this.model[this.path], 'st_ende_grund', date ? 'E' : null)
      }
    },

    /**
     * Add new single radiation to radiation list
     */
    addNewRadiation (index) {
      let radiation = {
        st_beginn_datum: this.model[this.pathRadiation][0].st_beginn_datum,
        selectedKindOfApplication: 'perkutan',
        selectedVersionOfDestination: 'code_version_2021',
        st_applikationsart: {
          perkutan: {
            zielgebiet: {},
            gesamtdosis: {},
            einzeldosis: {}
          }
        }
      }

      this.$set(this.model[this.pathRadiation], index, radiation)

      // setTimeout() is necessary to wait till validator has created validation fields
      setTimeout(() => {
        // trigger auto-save after adding new element to radiation-array
        if (this.validationRef.fields[this.pathRadiation + '.' + index + '.st_applikationsart.perkutan.stereotaktisch']) {
          this.validationRef.fields[this.pathRadiation + '.' + index + '.st_applikationsart.perkutan.stereotaktisch'].changed = true
        }
      }, 200)

      this.setSTZielgebietList(index)
    },

    /**
     * Delete selected single radiation
     *
     * @param index The index of selected radiation
     * @param field The field name to trigger validator and auto-save
     */
    deleteRadiation (index, field) {
      this.$delete(this.model[this.pathRadiation], index)
      this.validationRef.fields[field].changed = true
    },

    /**
     * Load unlinked therapies, when end of therapy is triggered or form with "behandlungsende" is loaded
     * Unlinked therapies are elements of list to link
     */
    getUnlinkedTherapies () {
      // set list of unlinked therapies on default
      this.listOfUnlinkedTherapies = []

      if (this.model[this.path].st_ende_therapie === 'J') {
        const config = {
          patientId: this.patientId,
          formId: this.id,
          subjId: this.subjId
        }

        this.$http.get('/documentation/getUnlinkedBeginTherapies/radiationTherapy?config=' + JSON.stringify(config))
          .then(res => {
            if (res.data) {
              // add found therapies to default list
              this.listOfUnlinkedTherapies = res.data
            }
          })
      }
    },

    /**
     * Open dialog to decide, if all base data of linked therapy should be overtaken
     */
    openLinkDialog () {
      this.updateIsRunning = true
      this.showLinkDialog = true
    },

    /**
     * Close link dialog
     */
    closeLinkDialog() {
      this.showLinkDialog = false
    },

    /**
     *  Set base data in dependency to selected parameter (all or only start date)
     *
     * @param parameter The selected kind of overtaking data
     */
    setLinkedBaseData (parameter) {
      if (this.linkedId) {
        // copy all base data from selected start therapy
        if (parameter === 'all') {

          // load data of linked therapy and set base values
          this.$http.get('/documentation/forms/' + this.linkedId)
            .then(res => {
              if (res.data?.form && res.data.form) {
                let radiation = lodash.cloneDeep(res.data.form.bestrahlung)

                radiation.forEach((element, index) => {
                  element.st_ende_datum = this.model[this.pathRadiation][0].st_ende_datum
                  element.selectedKindOfApplication = Object.keys(element.st_applikationsart)[0]

                  // set value of radio-group of version of destination
                  if (element.st_applikationsart[element.selectedKindOfApplication] && element.st_applikationsart[element.selectedKindOfApplication].zielgebiet) {
                    element.selectedVersionOfDestination = Object.keys(element.st_applikationsart[element.selectedKindOfApplication].zielgebiet)[0] || 'code_version_2021'
                  }

                  this.setSTZielgebietList(index)
                })

                this.$set(this.model, this.pathRadiation, radiation)
                this.$set(this.model[this.path], 'st_intention', res.data.form.base.st_intention)
                this.$set(this.model[this.path], 'st_stellung_op', res.data.form.base.st_stellung_op)
                this.$set(this.model[this.path], 'linked_therapy', this.linkedId)

                // update base data and linked id separately, because of updating model in Formdetails took too long, if slow internet connection
                if (this.id) {
                  const dataObject = {
                    id: this.id,
                    radiationTherapy: this.model
                  }

                  this.$http.put('/documentation/updateDataAfterLinkingTherapy', dataObject)
                    .then((res) => {
                      this.updateIsRunning = false

                      this.NotifySuccess(res, this.$t('FORMS_DIVERSE.MODULE_SYST_THERAPY_UPDATE_NOTIFICATION'))
                      // trigger get Data to show correct content of radiation therapy and trigger getMultiForms
                      // when not called, view shows correct content, but model in FormDetails has empty application values e.g. dosages
                      this.$emit('trigger-get-data')
                    })
                    .catch((error) => {
                      this.updateIsRunning = false
                      this.NotifyError(error)
                    })
                }
              }
            })
        } else {
          // set only date of linked therapy
          const linkedDate = this.listOfUnlinkedTherapies.find(therapy => this.linkedId === therapy._id).date
          this.$set(this.model[this.pathRadiation][0], 'st_beginn_datum', linkedDate)
          // set validator-flag to dirty to trigger auto-save
          this.validationRef.fields[this.pathRadiation + '.0.st_beginn_datum'].changed = true

          this.linkedId = null
          this.showLinkDialog = false
        }
      }
    },

    /**
     * Delete linked therapy, when start date should be set manually and trigger save
     */
    unlinkTherapy () {
      this.linkedId = null
      this.$delete(this.model[this.path], 'linked_therapy')
      this.validationRef.fields['base.linked_therapy'].changed = true
    },

    /**
     * Set value selectedKindOfApplication when triggering btn-group
     *
     * @param value The selected value
     * @param radiationIndex The index of selected single radiation
     */
    setKindOfApplication (value, radiationIndex) {
      // reset kind of application only, if new kind is selected e.g. perkutan -> kontakt
      if (Object.keys(this.model[this.pathRadiation][radiationIndex].st_applikationsart).indexOf(value) < 0) {
        this.$set(this.model[this.pathRadiation][radiationIndex], 'selectedKindOfApplication', value)
        this.$set(this.model[this.pathRadiation][radiationIndex], 'st_applikationsart', {})
        this.$set(this.model[this.pathRadiation][radiationIndex].st_applikationsart, this.model[this.pathRadiation][radiationIndex].selectedKindOfApplication, {zielgebiet: {}, gesamtdosis: {}, einzeldosis: {}})
      }
    },

    /**
     * Return label with required-star of field in dependency to report reason
     *
     * @param text The selected text of label
     * @param index The index of selected radiation
     * @param dependency The field selected element depends on
     *
     * @returns {VueI18n.TranslateResult}
     */
    formatRequiredLabel (text, index, dependency) {
      let label = this.$t(text)

      if (this.model[this.pathRadiation][index].st_ende_datum || Boolean(dependency)) label += ' *'

      return label
    }
  },
  computed: {
    diagDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).diagDate : undefined
    },
    deathDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).deathDate : undefined
    },
    subjId () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).subjId : undefined
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue && oldValue) {
          this.modelBase[this.path] = newValue[this.path]
          this.modelBase[this.pathRadiation] = newValue[this.pathRadiation]
          this.$emit('input', this.modelBase)
        }
      },
      immediate: true, deep: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.modelBase = newValue
          this.model[this.path] = newValue[this.path] || {}
          this.model[this.pathRadiation] = newValue[this.pathRadiation] || [{ st_applikationsart: {} }]

          this.isLinkedTherapy = this.model[this.path].st_ende_therapie === 'J' && this.model[this.path].linked_therapy ? 'J' : 'N'

          // set helper-property in dependency to existing linked therapy
          if (this.model[this.path].st_ende_therapie === 'J' && this.model[this.path].linked_therapy) {
            this.linkedId = this.model[this.path].linked_therapy
          } else {
            this.linkedId = null
          }

          // set value of radio-group of kind of application
          if (this.model[this.pathRadiation] && this.model[this.pathRadiation].length > 0) {
            this.model[this.pathRadiation].forEach((element, index) => {
              element.selectedKindOfApplication = Object.keys(element.st_applikationsart)[0]
              // set value of radio-group of version of destination
              if (element.st_applikationsart[element.selectedKindOfApplication] && element.st_applikationsart[element.selectedKindOfApplication].zielgebiet) {
                element.selectedVersionOfDestination = Object.keys(element.st_applikationsart[element.selectedKindOfApplication].zielgebiet)[0] || 'code_version_2021'
                // set individual destination list to each single radiation
                this.setSTZielgebietList(index)
              }
            })
          }
        }
      },
      immediate: true
    },
    reloadUnlinkedTherapies: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue && newValue) {
          // load list of unlinked therapies after saving form with changed report reason
          this.getUnlinkedTherapies()
        }
      },
      immediate: true
    },
    id: {
      handler: function () {
        this.isLinkedTherapy = this.model[this.path].st_ende_therapie === 'J' && this.model[this.path].linked_therapy ? 'J' : 'N'

        // load list of unlinked therapies, if shown therapy has report reason "behandlungsende"
        this.getUnlinkedTherapies()
      },
      immediate: true
    }
  }
}
</script>
